module.exports = __webpack_public_path__ + "media/Video 103b.be0b0e42.mp4";